import { Button } from "@heroui/react";
import { IconPlus, IconMinus, IconEye } from "@tabler/icons-react";
import { useAddCard } from "@/stores/deckStore";

export default function Buttons({
  buttonSize = "20px",
  handleOpen,
  aaCardId,
}: {
  buttonSize?: string;
  handleOpen: any;
  aaCardId: string;
}) {
  const addCard = useAddCard();
  return (
    <>
      <Button
        isIconOnly
        // color="primary"
        // variant="ghost"
        onPress={() => handleOpen(aaCardId)}
        radius="full"
        className="bg-slate-800 min-w-0 min-h-0 h-[20px] w-[20px] invisible group-hover:visible mt-[2px] outline outline-1 outline-offset-[-1px] outline-slate-200"
        style={{
          height: buttonSize,
          width: buttonSize,
        }}
      >
        <IconEye height={18} width={18} />
      </Button>
      <Button
        isIconOnly
        radius="full"
        className="bg-slate-800 min-w-0 min-h-0 h-[20px] w-[20px] invisible group-hover:visible mt-[2px] outline outline-1 outline-offset-[-1px] outline-slate-200"
        onPress={() => {
          addCard(aaCardId, 1);
        }}
        style={{
          height: buttonSize,
          width: buttonSize,
        }}
      >
        <IconPlus height={18} width={18} />
      </Button>
      <Button
        isIconOnly
        radius="full"
        className="bg-slate-800 min-w-0 min-h-0 h-[20px] w-[20px] invisible group-hover:visible mt-[2px] outline outline-1 outline-offset-[-1px] outline-slate-200"
        onPress={() => addCard(aaCardId, -1)}
        style={{
          height: buttonSize,
          width: buttonSize,
        }}
      >
        <IconMinus height={18} width={18} />
      </Button>
    </>
  );
}
